<div class="modal-content">
  <div class="modal-header">
    <p class="modal-title font-16 mb-0 text-dark">
      <span>{{ 'settings.page_title_view' | translate }}</span>
    </p>
    
    <button (click)="activeModal.dismiss()" aria-label="Close" class="close">
      <span aria-hidden="true" class="font-24 text-muted">
        <i class="mdi mdi-close"></i>
      </span>
    </button>
  </div>
  
  <div class="modal-body">
    <div class="row mb-3">
      <div class="col-md-12">
        <div class="card mb-0 shadow-none">
          <div class="card-body p-0">
            <div class="mb-3">
              <ng-container *ngIf="availableWidgets$ | async; let availableWidgets">
                <!-- Dashboard widgets order form -->
                <ng-container *ngIf="entity === 'dashboard'">
                  <div class="mb-2 py-2 heading-row">
                    <div class="row">
                      <div class="col-12">
                        <strong>{{ ('settings.appearance.' + entity + '.category_widgets_config') | translate }}</strong>
                      </div>
                    </div>
                  </div>
                  <div *ngFor="let widget of dashboardWidgetsForm; let isLast = last; let index = index" class="row">
                    <div class="col-12 py-2">
                      <div class="row">
                        <div class="py-0 pr-2 col">
                          <div>{{ ('settings.appearance.' + entity + '.' + widget.name) | translate }}</div>
                          <small class="text-muted">{{ ('settings.user_type_' + widget.user_type + '_description') | translate }}</small>
                          <div *ngIf="widget.name === 'employee_stats'"><u class="text-muted" fragment="attendance_stats" routerLink="/setting/appearance">{{'settings.appearance.employee.category_setting' | translate}}</u></div>
                        </div>
                        <div class="col-auto">
                          <input (change)="onShowChange($event, widget)"
                                 [checked]="widget.show"
                                 [disabled]="widget.disabled && widget.name !== 'stopwatch'"
                                 [readOnly]="widget.disabled && widget.name !== 'stopwatch'"
                                 data-switch="success"
                                 id="{{ entity + '.' + widget.name }}"
                                 name="{{ entity + '.' + widget.name }}"
                                 type="checkbox"
                          >
                          <label [ngStyle]="{'opacity': (widget.disabled && widget.name !== 'stopwatch') ? 0.5 : 1}" class="m-0 mr-2" for="{{ entity + '.' + widget.name }}">&nbsp;</label>
                          <button (click)="moveUp(widget)" [disabled]="widget.disabled || index === 3" class="btn btn-icon btn-light mr-2"><i class="mdi mdi-menu-up"></i></button>
                          <button (click)="moveDown(widget)" [disabled]="widget.disabled || isLast" class="btn btn-icon btn-light"><i class="mdi mdi-menu-down"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngFor="let category of availableWidgets[entity] | keyvalue">
                  <ng-container *ngIf="!hiddenCategories.includes(category.key)">
                    <div class="mb-2 py-2 heading-row">
                      <div class="row">
                        <div class="col-12">
                          <strong>{{ ('settings.appearance.' + entity + '.category_' + category.key) | translate }}</strong>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3 mt-2">
                      <ng-container *ngFor="let widget of category.value | keyvalue" class="">
                        <div *ngIf="!hiddenWidgets.includes(widget.key)" class="col-6 mb-2 mt-2">
                          <div class="toggler">
                            <div class="d-flex w-100">
                              <div class="py-0 pr-2 w-100">
                                <span *ngIf="category.key !== 'custom_fields'">{{ ('settings.appearance.' + entity + '.' + widget.key) | translate }}</span>
                                <span *ngIf="category.key === 'custom_fields'">{{ widget.value.label }}</span>
                              </div>
                              <div class="flex-0">
                                <input (change)="changeWidgets(entity, category.key, (category.key === 'custom_fields' ? widget.value.custom_field_definition_ID : widget.key.toString()), $event)"
                                       [checked]="(category.key === 'custom_fields' ? widget.value.enabled : widget.value)"
                                       data-switch="success"
                                       id="{{ entity + '.' + widget.key }}"
                                       name="{{ entity + '.' + widget.key }}"
                                       type="checkbox"
                                >
                                <label class="m-0" for="{{ entity + '.' + widget.key }}">&nbsp;</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
